import api from "./api";

const dprLabourReportService = {
  getReport: async (params) => {
    const res = await api.get("/dprLabourReport/getReport", { params });
    return res.data;
  },

  getLocationsByProject: async (projectId) => {
    const res = await api.get(`/dprLabourReport/locations/${projectId}`);
    return res.data;
  },

  getVendorsByProject: async (projectId) => {
    const res = await api.get(`/dprLabourReport/vendors/${projectId}`);
    return res.data;
  },
};

export default dprLabourReportService;
